/**
 * Keys we use in cookies, local, and session storage.
 */

export const USER_CONTENT = 'userContent';
